import { Product } from "../types/types";
import { useState, useEffect } from "react";
import { FeatureFlags } from "@packages/feature-flags";
import { isOutOfStock, isRetiredProduct } from "./product";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";

export const useVisibleProducts = (
  products: Product[],
  flags: FeatureFlags,
  ref: React.RefObject<HTMLElement | null>,
) => {
  const [visibleProducts, setVisibleProducts] = useState(
    filterVisibleProducts(
      products,
      !!flags.hideOutOfStocks?.value,
      !!flags.hideRetiredProducts?.value,
    ),
  );

  useEffect(
    function updateVisibleProductsFromProps() {
      setVisibleProducts(
        filterVisibleProducts(
          products,
          !!flags.hideOutOfStocks?.value,
          !!flags.hideRetiredProducts?.value,
        ),
      );
    },
    [products, flags.hideOutOfStocks, flags.hideRetiredProducts],
  );

  useEffect(function subscribeToRemoveProductEvents() {
    const handleRemoveProduct = (event: Event) => {
      const removeEvent = event as CustomEvent<{ pimProductId: string }>;
      const removedProductId = removeEvent.detail?.pimProductId;

      if (!removedProductId) {
        return;
      }

      setVisibleProducts((currentProducts) =>
        currentProducts.filter(
          (product) => product.aliases?.pimProductId !== removedProductId,
        ),
      );
    };

    const root = ref.current?.getRootNode();

    root?.addEventListener(
      productCardEvents.removeProduct,
      handleRemoveProduct,
    );

    return function unsubscribeFromRemoveProductEvents() {
      root?.removeEventListener(
        productCardEvents.removeProduct,
        handleRemoveProduct,
      );
    };
  }, []);

  return visibleProducts;
};

const filterVisibleProducts = (
  products: Product[],
  hideOutOfStocks: boolean,
  hideRetiredProducts: boolean,
): Product[] => {
  return products.filter((product) => {
    if (
      (hideOutOfStocks && isOutOfStock(product)) ||
      (hideRetiredProducts && isRetiredProduct(product))
    ) {
      return false;
    }

    return true;
  });
};
